import * as React from "react";

interface LoaderProps {
  message?: string;
  subMessage?: string;
}

const Loader = ({ 
  message = "Loading...", 
  subMessage = "Please wait" 
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div>{message}</div>
      <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
        {subMessage}
      </div>
    </div>
  );
};

export default Loader;
